import React from "react";
import PropTypes from "prop-types";
//import { Test } from './StoreJs.styles';

const Store010 = (props) => (
  <div className="feature">
    <h3>Dream Chimney Store</h3>
    <a href="https://dreamchimney.bigcartel.com/product/dream-chimney-dc-shirt" target="_blank">
      <img
        src="//www.dreamchimney.com/mainpage/merch/dc-shirts-300.gif"
        className="img-responsive center-block"
        style={{ margin: "0 auto" }}
        alt="Dream Chimney Shirts"
      />
      <div className="featureTextFooter">
        <strong>
          Dream Chimney Shirts
          <br />
          Re-stocked in new colors
          <br />
          Shipping Worldwide &raquo;
        </strong>
      </div>
    </a>
  </div>
);

export default Store010;
